export default __webpack_public_path__ + "static/media/hover-resend-btn.c6587348.svg";